import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { first } from 'rxjs/operators';
import { AdminProjectService, AnalyticsService, ContactSearchVM, VerbXApiService, XapiProgramActivityVM, XAPIProgramVM, XAPIVerbVM } from 'src/app/shared/services/api';

@Component({
  selector: 'app-x-api-form',
  templateUrl: './x-api-form.component.html',
  styleUrls: ['./x-api-form.component.scss']
})
export class XAPIFormComponent implements OnInit {
  programs: XAPIProgramVM[] = [];
  activities: XapiProgramActivityVM[] = [];
  projectTitle: string = "";
  projectId: number = -1;
  contacts: ContactSearchVM[] = [];
  verbs: XAPIVerbVM[] = [];
  contactsOnly: boolean = false;
  model: any = {};

  constructor(private service: AnalyticsService,
    private verbService: VerbXApiService,
    private adminProjectservice: AdminProjectService,
    private dialogRef: MatDialogRef<XAPIFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.projectId = data.projectId;
    this.projectTitle = data.projectTitle;
    this.contactsOnly = data.loadContact;

  }

  ngOnInit(): void {

    this.service.analyticsGetProgramsGet().pipe(first()).subscribe(result => {
      this.programs = result;

    })

    this.verbService.verbXApiSearchVerbPost({ filterExpression: "", pageIndex: 1 }).pipe(first())
      .subscribe(result => {
        this.verbs = result.entities!;
      })

    if (this.contactsOnly) {
      this.adminProjectservice.adminProjectSearchProjectContactsPost(this.projectId, {
        sortExpressions: ["FirstName asc"],
        pageIndex: 1,
        filterExpression: ""
      }).pipe(first()).subscribe(result => {
        console.log(result)
        this.contacts = result.entities!;


      })
    }
  }

  loadActivities() {
    this.service.analyticsGetProgramActivitiesGet(this.model.program.id).pipe(first()).subscribe(result => {
      this.activities = result;
    })
  }

  submit(form: NgForm) {
    (Object).values(form.controls).forEach(cont => {
      cont.markAsTouched();
    })

    if (form.invalid) {
      return;
    }
    let id = this.newGuid();
    let xapiObj = {
      id:id,
      identifier:id,
      "program":{
        'name':this.model.program.name
      },
      "actor": {
        "objectType": this.contactsOnly?"Contact":"Guest",
        "name": this.contactsOnly?(this.model.actor.FirstName + " " + this.model.actor.lastName):this.model.actor,
      },
      "verb": {
        "id": this.model.verb.verbId,
        "display": {
          "en-US": this.model.verb.en
        }
      },
      "object": {
        "objectType": this.model.activity.name,
        "id": this.model.activity.xapiId??this.model.activity.id,
        "desc":this.model.activity.description
      }
    }
    if(this.model.result){
      (xapiObj as any)["result"] = {
        response: this.model.result
      }
    }
    console.log(xapiObj)
    this.service.analyticsMerlinIngestActionPost(JSON.stringify(xapiObj)).pipe(first()).subscribe(result => {
      this.model.actor = undefined;
      this.model.result = undefined;
    })

    

  }

  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  
  reset(form: NgForm, all: boolean = false) {
    if (all) {
      form.resetForm();
    } else {
      this.model.actor = undefined;
      this.model.result = undefined;
    }

  }

}
